import { IllustratedMessage, Loader } from '@percent/lemonade'

import { useOrganisationProfile } from '../../hooks/useOrganisationProfile'
import { useTranslation } from '../../hooks/useTranslation'
import { OrganisationDonationSummary } from '../OrganisationDonationSummary/OrganisationDonationSummary'
import { OrganisationProfileCard } from '../OrganisationProfileCard/OrganisationProfileCard'

export type OrganisationProfilePageProps = {
  organisationId: string
}

export function OrganisationProfilePage({
  organisationId,
}: Readonly<OrganisationProfilePageProps>) {
  const { t } = useTranslation()
  const { data, isLoading, error } = useOrganisationProfile(organisationId)

  if (isLoading) return <Loader />

  if (error || !data) {
    return (
      <IllustratedMessage
        illustration="invalid-link"
        title={t('profile.error.title')}
        description={t('profile.error.description')}
      />
    )
  }

  return (
    <OrganisationProfileCard profile={data}>
      {data.donations && (
        <OrganisationDonationSummary
          organisationId={data.organisation.id}
          donations={data.donations}
        />
      )}
    </OrganisationProfileCard>
  )
}
